import React, { useContext, useEffect } from 'react';
import { useVirtual } from 'react-virtual';
import { Context } from '@front10/helpers/dist/Context';
import LocationSelectorGroupHeader from './LocationSelectorGroupHeader';
import LocationSelectorMenuItem from './LocationSelectorMenuItem';

const getAriaSelectedValue = ({
  notifySelectedState,
  useInput,
  locationItemProps,
  selectedItem,
  item
}) => {
  let ariaSelectedValue = {};
  if (notifySelectedState) {
    if (useInput) {
      ariaSelectedValue['aria-selected'] = locationItemProps.props['aria-selected'];
    }
  } else {
    if (selectedItem?.value === item?.value) {
      ariaSelectedValue['aria-selected'] = locationItemProps.props['aria-selected'];
    }
  }
  return ariaSelectedValue;
};

const RowVirtualizerDynamic = ({
  items,
  dropDownHeight,
  size,
  itemsProps,
  grouped,
  displayField,
  id,
  itemHeight,
  highlightedIndex,
  itemRenderer,
  getItemProps,
  customAccessibility,
  enableVirtualList,
  enabledAccessibilityLabel,
  getMenuProps,
  wasOpenFirstTime,
  useInput,
  openOnFocus,
  selectedItem,
  notifySelectedState
}) => {
  const parentRef = React.useRef();
  const { translate } = useContext(Context);
  const rowVirtualizer = useVirtual({
    size,
    parentRef,
    overscan: 2
  });

  const menuProps = getMenuProps();
  const newMenuProps = {
    'aria-labelledby': null
    // role: !useInput ? null : menuProps['role']
  };

  // Scroll virtualizer to currently highlighted item
  useEffect(() => {
    if (highlightedIndex !== undefined) {
      rowVirtualizer.scrollToIndex(highlightedIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightedIndex]);

  return (
    <div className="fr-dropdown-list-container" tabIndex={-1}>
      <ol
        role="listbox"
        className="fr-px-0 fr-ol"
        tabIndex={-1}
        {...getMenuProps({
          ref: parentRef,
          style: {
            margin: 0,
            padding: 0,
            position: 'relative',
            overflowY: 'auto',
            maxHeight: dropDownHeight,
            width: '100%'
          }
        })}
        {...newMenuProps}
        id={`${menuProps['id']}-list`}
      >
        <div
          style={{
            height: `${rowVirtualizer.totalSize}px`,
            width: '100%',
            position: 'relative'
          }}
        >
          {rowVirtualizer.virtualItems.map((virtualRow) => {
            const item = items[virtualRow.index];
            const Tag = grouped && item.category ? 'div' : 'li';

            const locationItemProps = itemsProps(
              virtualRow.index,
              highlightedIndex,
              items,
              getItemProps
            );
            const ariaSelectedValue = getAriaSelectedValue({
              notifySelectedState,
              useInput,
              locationItemProps,
              selectedItem,
              item
            });

            let newAriaLabel = item[displayField];
            if (enabledAccessibilityLabel) {
              newAriaLabel = `${
                selectedItem.label === item.label
                  ? translate('cmp-location-selector-selected-prefix', 'Selected')
                  : ''
              } ${item[displayField]}`;
            }

            const result = (
              <Tag
                {...locationItemProps.attrs}
                {...locationItemProps.itemProps}
                //{...locationItemProps.props}
                key={items[virtualRow.index].value}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  marginTop: 0,
                  marginBottom: 0,
                  minHeight: `${itemHeight}px`,
                  width: '100%',
                  transform: `translateY(${virtualRow.start}px)`,
                  display: `${item.virtual ? 'none' : 'block'}`
                }}
                ref={virtualRow.measureRef}
                {...ariaSelectedValue}
                role="option"
                aria-posinset={virtualRow.index + 1}
                aria-setsize={size}
                id={id ? `${id}-item-${virtualRow.index}` : undefined}
              >
                {grouped && item.category ? (
                  <LocationSelectorGroupHeader {...locationItemProps.props}>
                    {itemRenderer(item)}
                  </LocationSelectorGroupHeader>
                ) : (
                  <LocationSelectorMenuItem
                    {...locationItemProps.props}
                    id={id ? `${id}-item-${virtualRow.index}-text` : undefined}
                    ariaLabel={
                      customAccessibility
                        ? `${newAriaLabel} ${virtualRow.index + 1} ${translate(
                            'cmp-location-selector-separator',
                            'of'
                          )} ${size}`
                        : enabledAccessibilityLabel
                        ? newAriaLabel
                        : item[displayField]
                    }
                    customAccessibility={customAccessibility}
                    wasOpenFirstTime={wasOpenFirstTime}
                    openOnFocus={openOnFocus}
                    useInput={useInput}
                    enabledAccessibilityLabel={enabledAccessibilityLabel}
                  >
                    {itemRenderer(item)}
                  </LocationSelectorMenuItem>
                )}
              </Tag>
            );
            //  debugger;
            return !size || (size && virtualRow.index < size) ? result : null;
          })}
        </div>
      </ol>
    </div>
  );
};

export default RowVirtualizerDynamic;
